<header class="team-header">
  <span class="team-logo">Nyzed</span>
  <button class="team-logout" (click)="logout()">Esci</button>
</header>
<main class="team-main">
  <router-outlet />
</main>
